const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];
export const dateFormatter = (inputDate: string) => {
  const date = new Date(inputDate);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${month}. ${day}, ${year}`;
};

export const formatDate = (dateObj: any) => {
  const date = new Date(dateObj);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

//  if need we can use this with a given date in future
export const getCurrentUTCTime = () => {
  // Get the current date and time
  const date = new Date();

  // Get the current year, month, and day
  const year = date.getUTCFullYear();
  const month = months[date.getUTCMonth()];
  const day = date.getUTCDate();

  let hours: any = date.getUTCHours();
  let minutes: any = date.getUTCMinutes();

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  // Get the timezone offset in minutes
  const timezoneOffsetMinutes = date.getTimezoneOffset();

  // Calculate the timezone offset in hours and minutes
  const offsetHours = Math.floor(Math.abs(timezoneOffsetMinutes) / 60);
  const offsetMinutes = Math.abs(timezoneOffsetMinutes) % 60;

  // Format the timezone offset to always have two digits
  const formattedOffsetHours =
    offsetHours < 10 ? "0" + offsetHours : offsetHours;
  const formattedOffsetMinutes =
    offsetMinutes < 10 ? "0" + offsetMinutes : offsetMinutes;

  // Determine if the offset is positive or negative
  const offsetSign = timezoneOffsetMinutes > 0 ? "-" : "+";

  // Combine the time and timezone offset into the desired format
  const formattedDateTime = `${month} ${day}, ${year} ${hours}:${minutes} (UTC${offsetSign}${formattedOffsetHours}:${formattedOffsetMinutes})`;

  return formattedDateTime;
};

export const getDiffInMinutes = (date1: any, date2: any) => {
  const startTime = new Date(date1);
  const endTime = new Date(date2);
  const difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
  return Math.round(difference / 60000);
};
